export default {
    query: {
        form_fixed: true
    },
    form:{
        ignore_col_layout: true,
    },
    table: {
        border: true,
        stripe: true,
        align: 'center'
    },
    localeList: [
        {value: 'zhCn', label: '简体中文'},
        {value: 'en', label: 'English'}
    ]
}

